window.theme = window.theme || {};
//if(Number.isInteger(getParamsValues[i])){
var cartItems ='';
var baseURL='https://backoffice.itspearltimevendor.com';
var vendorId='';
var partycode='';
(function($){
	var $ = jQuery = $;

	window.addEventListener('load', function() {

      /************Remove Popup content****************************/
      theme.genie.addAttributesToCart({"attributes[hideVendorPopup]": '',"attributes[hideVendordate]": ''}).then(function(response) {
          console.log('Removed Hide vendor popup');
      }).always(function () {

      }.bind(this));
      /************************************************************/
      //Get vendor id from url
		var getParamsValues = theme.genie.getUrlParams();
      //console.log(getParamsValues);
		for (let i in getParamsValues) {
			if(i=='vendor'){
				var vendorValue = parseInt(getParamsValues[i])*1;
				if(Number.isInteger(vendorValue)){
					vendorId = vendorValue;
					$('body').attr("data-getcookie",vendorId);
				}
			}
			if(i=='partycode'){
				$('body').attr("data-getparty",getParamsValues[i]);
			}
		}
// console.log('Hide Button');
		if(vendorId=='' || vendorId==undefined){
			if($(".vendor_handle").length){
				vendorId = $(".vendor_handle").val();
				$('body').attr("data-getcookie",vendorId);
			}
			if($(".cart_page_vendor_id").length){
				vendorId = $(".cart_page_vendor_id").val();
				$('body').attr("data-getcookie",vendorId);
			}
			if($(".cart_page_party_code").length){
				partycode = $(".cart_page_party_code").val();
			}
		}
		var url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
		var vFlag=false;

		for (var i = 0; i < url.length; i++) {
			var urlparam = url[i].split('=');
			console.log(urlparam);
			if(url.length>0){
				var vendorValue = parseInt(urlparam[i])*1;
				if(urlparam[0] == "vendor" && urlparam[1] !='' && Number.isInteger(vendorValue)){
					vendorId = urlparam[1];
					vFlag=true;
				}
				if(urlparam[0] == "partycode" && urlparam[1] !=''){
					partycode = urlparam[1];
					vFlag=true;
				}
			}
		}
		if(vendorId!='' && vendorId!=undefined){
			theme.genie.getvendorsDatas(vendorId,partycode).then(function(vendorsInfo) {

				/**************************************/
				theme.genie.addAttributesToCart({"attributes[vendtitle]": vendorsInfo['vend_nickname'],"attributes[vendorid]": vendorId,"attributes[hideVendorPopup]": '',"attributes[hideVendordate]": ''}).then(function(response) {
					console.log('vendor id created');
				}).always(function () {

				}.bind(this));               
				/*******************************************/
				$("#party_code").val(vendorsInfo['partyCode']);
				$(".product_party_code").val(vendorsInfo['partyCode']);
				if(vendorsInfo['partyCode']!=''){
					$(".customerParty").val(vendorsInfo['partyCode']);
					$(".customerParty").prop('readonly', true);
				}

				$(".product-buy-buttons--root").show();
				$(".product-buy-buttons--primary").show();
				if(vendorsInfo['vend_id']=='37'){
					$(".hide_vendor").show();
				}
				if(vendorsInfo['vend_id']!=''){
					$(".product_vendor_id").val(vendorsInfo['vend_id']);
				}
				$(".product_vendor_title").val(vendorsInfo['vend_nickname']);
				if(vendorsInfo['facebook']!=''){ //facebook
					$(".facebook").show();
					$(".facebook").attr("href", vendorsInfo['facebook']);
				}
				if(vendorsInfo['twitter']!=''){ //Tiktok
					$(".tiktok").show();
					$(".tiktok").attr("href", vendorsInfo['twitter']);
				}
				if(vendorsInfo['instagram']!=''){ //instagram
					$(".instagram").show();
					$(".instagram").attr("href", vendorsInfo['instagram']);
				}
				if(vendorsInfo['youtube']!=''){ //Youtube
					$(".youtube").show();
					$(".youtube").attr("href", vendorsInfo['youtube']);
				}
				if(vendorsInfo['teetime']!=''){ //Youtube
					$(".teetime").show();
					$(".teetime").attr("href", vendorsInfo['teetime']);
				}else{
					$(".teetime").show();
					$(".teetime").attr("href", 'https://teetimeam.com/');
				}
				if(vendorsInfo['letishe']!=''){ //Youtube
					$(".letishe_logo").show();
					$(".letishe_logo").attr("href", vendorsInfo['letishe']);
				}else{
					$(".letishe_logo").show();
					$(".letishe_logo").attr("href", 'https://letishe.com');
				}
				if($("#shopify-section-template--14380024758385__slideshow .featured-content--title").length){
					$("#shopify-section-template--14380024758385__slideshow .featured-content--title").text(vendorsInfo['vend_nickname']);
					$("#shopify-section-template--14380024758385__slideshow .featured-content--description").text('Its Pearl Time, Independent Consultant');
					$("#shopify-section-template--14380024758385__slideshow .featured-content--link--container").attr("href","https://itspearltime.com/collections/pendants?vendor="+vendorsInfo['vend_id']);
				}
				if($("#shopify-section-template--14380025118833__slideshow .featured-content--title").length){
					$("#shopify-section-template--14380025118833__slideshow .featured-content--title").text(vendorsInfo['vend_nickname']);
					$("#shopify-section-template--14380025118833__slideshow .featured-content--description").text('Its Pearl Time, Independent Consultant');
					$("#shopify-section-template--14380025118833__slideshow .featured-content--link--container").attr("href","https://itspearltime.com/collections/pendants?vendor="+vendorsInfo['vend_id']);
				}
				$('#overlay_genie').removeClass('overlay_genie');
				console.log(vendorsInfo);
			}).fail(function() {
				$('#overlay_genie').removeClass('overlay_genie');
			});
		}else{
			if($(".gift_cart").length){
				$(".product-buy-buttons--root").show();
				$('#overlay_genie').removeClass('overlay_genie');
			}else{
				if($(".product-buy-buttons--root").length){
// $(".product-buy-buttons--root").hide();
				}
			}
			$('#overlay_genie').removeClass('overlay_genie');
		}
		var modal = document.getElementById('myModal');
		var thankmodal = document.getElementById('thanksModal');
		var span = document.getElementsByClassName("close")[0];
		if($('body').data('getcookie') !='' && $('body').data('getcookie') !=undefined){
			var vandorCookieVal = $('body').data('getcookie');

			if(vandorCookieVal !='' && $('body').data('getcookie') !=undefined){
				vendorId = vandorCookieVal;
			}
		}


		if(!vFlag && (vendorId=='' || vendorId==undefined)){
            //$(".social--grid").css('visibility', 'hidden');
            let currentDate = new Date().toJSON().slice(0, 10);
			if($(".hidePopupClass").val()=='VendorRemoved' && $(".hidePopupDate").val()==currentDate){
				$(".product-buy-buttons--root").show();
			    $(".product-buy-buttons--primary").show();
			}else{
              modal.style.display = "block";              
            }
		}else{
			$(".social--grid").css('visibility', 'display');
		}

		/*if($('.product-page--root').length){
		if(!vFlag && vendorId!='' && vendorId!=undefined){
		var productpage  = window.location.href;
		var queryParam =  productpage.includes('?');
		if(queryParam){
		window.location.href =productpage + '&vendor='+vendorId;
		}else{
		window.location.href = productpage + '?vendor='+vendorId;
		}
		}
		}*/
		if($('.cart--root').length){
			if($('.cart--root').data('view')=='desktop'){
				console.log("VF-"+vFlag);
				console.log("VF-"+vendorId);
				if(!vFlag && vendorId!='' && vendorId!=undefined){

//window.location.href = window.location.href + '?vendor='+vendorId;
					getPartiesData(vendorId);
					if($("#party_code").lenght && $("#party_code").val()!=''){
						$("#customerParty").val($("#party_code").val());
						$("#customerParty").attr('readonly','readonly');
					}else{
// $("#customerParty").val('');
					}
				}
			}
		}

		$('#autovendor').autocomplete({
			minLength: 1,
			ajaxSettings : {crossDomain: true},
//ajaxSettings: { jsonpCallback: 'json_call' },
//dataType: 'jsonp',
			serviceUrl: baseURL + '/shopify/process/getallvendors',    //getAllVendors(),
			onSelect: function (suggestion) {
				$('#autovendor').val(suggestion.value);
              window.location.href = 'https://itspearltime.com/pages/'+suggestion.data;
				// var qpar = window.location.href.includes('?');
				// if(qpar){
				// 	window.location.href = window.location.href+ '&vendor='+suggestion.data+'&selectop='+$('#selectedOption').val();
				// }else{
				// 	window.location.href = window.location.href+ '?vendor='+suggestion.data+'&selectop='+$('#selectedOption').val();
				// }
				/*    modal.style.display = "none";
				thankmodal.style.display = "block";
				setTimeout(function() {
				thankmodal.style.display = "none";
				window.location.href = "https://itspearltime.com/pages/" +suggestion.data+ '?vendor='+suggestion.data;
				}, 2000);   1
				*/
			},
			onSearchComplete:function (query, suggestion) {
				/*if(suggestion.length == 0){
				$('#autolocation').notify('No location found',{ position:"bottom center", className: "error",closeOverlay: false } );
				}*/
			}
		});
		span.onclick = function() {
			modal.style.display = "none";
		}

		window.onclick = function(event) {
			if (event.target == modal) {
				modal.style.display = "none";
			}
		}
		if($(".dynamic-checkout__content").length){
//$(".dynamic-checkout__content").hide();
		}
		$('a').each(function() {
			var href = $(this).attr('href');
			if (href != '#' && href !=undefined &&  href !='undefined') {
				var vendorIds =  href.includes('vendor=');
				var partycodeIds =  href.includes('partycode=');
				if(vendorIds){
					if(partycodeIds){}else{
						$(this).attr('href', href + '&partycode='+partycode);
					}
				}else{
					var queryParam =  href.includes('?');
					var vendorValue = parseInt(vendorId)*1;
					if(vendorId!='' && Number.isInteger(vendorValue)){
						if(queryParam){
							$(this).attr('href', href + '&vendor='+vendorId+'&partycode='+partycode);
						}else{
							$(this).attr('href', href + '?vendor='+vendorId+'&partycode='+partycode);
						}
					}
				}
			}
		});
		$('.filter--link .filter--input').each(function() {
			var value = $(this).val();

			if (value != '#' && value !=undefined &&  value !='undefined') {
				var vendorIds =  value.includes('vendor=');
				var partycodeIds =  value.includes('partycode=');
				if(vendorIds){
					if(partycodeIds){}else{
						$(this).val(value+"&party_code="+partyCode);
					}
				}else{
					var queryParam =  value.includes('?');
					var vendorValue = parseInt(vendorId)*1;
					if(vendorId!='' && Number.isInteger(vendorValue)){
						if(queryParam){
							$(this).val(value+'&vendor='+vendorId);
						}else{
							$(this).val(value+'?vendor='+vendorId);
						}
					}
				}
			}

		});


		if(vendorId=='37'){
			if($(document).find('.vend37').length){
				$(document).find('.vend37').show();
			}
		}
		if($('.parties').length){
			getPartiesData(vendorId);
		}
		if($('#customerParty').length){
			if($("#party_code").lenght && $("#party_code").val()!=''){
				$("#customerParty").val($("#party_code").val());
				$("#customerParty").attr('readonly','readonly');
			}
		}
		/*********************************************************************/
		var selectVar=false;
		var url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
		var selectedOption='';
		for (var i = 0; i < url.length; i++) {
			var urlparam = url[i].split('=');
			if(url.length>0){
				if(urlparam[0] == "selectop" && urlparam[1] !=''){
					var selectedOption = urlparam[1];
				}
			}
		}
		if(selectedOption!='' && decodeURIComponent(selectedOption)!=''){
			$.LoadingOverlay("show");
			var interValHandle = setInterval(function () {
				console.log('dedecting......');
				$('.product-page--left-column').find('.image-picker-item').each(function(){
					if($(this).data('name')==decodeURIComponent(selectedOption)){
                          clearInterval(interValHandle);
                            $.LoadingOverlay("hide");
						$(this).find('img').trigger('touchstart');
						
					}
				});
			}, 1000);
		}
		/************************************************************************/
		if(vendorId=='' || vendorId==undefined){
			theme.genie.addAttributesToCart({"attributes[consultantId]": '37'}).then(function(response) {
				console.log('consultant id created');
			}).always(function () {

			}.bind(this));
		}
      /************************************For Add reward product********************/
            
      var url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');       
      for (var i = 0; i < url.length; i++) {  
          var urlparam = url[i].split('=');   
          if(url.length>0){ 
            if(urlparam[0] == "vendor" && urlparam[1] !=''){
              var vendorId=urlparam[1];
            }
            if(urlparam[0] == "rewards" && urlparam[1] !=''){ 
              $.LoadingOverlay("show");
              try{
              var params  = atob(urlparam[1]);
               var cartItems = $.parseJSON(params);
                 console.log("Cart data",cartItems); 
               theme.genie.addItemsToCart(cartItems).then(function(cart) { 
                 console.log(cart); 
                 window.location="https://itspearltime.com/cart/";
                 $.LoadingOverlay("hide");
               });    
              }catch(err){
                //$.LoadingOverlay("hide");
                alert('something went wrong!');
                window.location="https://itspearltime.com/pages/"+vendorId;               
              }finally{
                $.LoadingOverlay("hide");
              }
              break;              
            }
          }
      }     
    
      /*******************************************************************************/
	});


	$(document).ready(function(){
		var modal = document.getElementById('shareModel');
		$('.close').click(function(){
//modal.style.display = "none";
			$('.modalc').hide();
		});
		$(window).click(function(event) {
			if (event.target == modal) {
//modal.style.display = "none";
				$('.modalc').hide();
			}
		});
//For Product detail page


// console.log('Cart ',$(this).data('cart'));
		$('.share_cart').click(function(){
			var modal = document.getElementById('shareModel');
			var urlsData = $(this).data('cart');
			var url = urlsData.split('-');
			var _items = [];
			for (var i = 0; i < url.length; i++) {
				var urlparam = url[i].split('_');
				if(url.length>0){
					_items.push(
						{
							quantity: urlparam[1],
							id:urlparam[0],
							properties:{
								"Vendor":$(".cart_page_vendor_id").val(),
								"Vendor Nickname":$(".cart_page_vendor_name").val(),
								"Source":"Cart Share"
							}
						}
					)
				}
			}
			var AllItem =  JSON.stringify({items: _items });
			var copyURL="https://itspearltime.com/pages/social-sharing?vendor="+$(".cart_page_vendor_id").val()+"&params=";
			var params = btoa(AllItem);
			copyURL = copyURL+params;
//modal.style.display = "block";
			$(".modalc").show();
			setTimeout(function(){
				$('.shrcls').attr('data-url', copyURL);
			}, 3000);


			console.log(copyURL);
//var param2 = atob(params);

		});


		$('.accordion--tab').click(function(){
			if($(this).hasClass('active')){
				$('.accordion--tab').removeClass('active');
				$('.accordion--data').slideUp();
			}else{
				$('.accordion--tab').removeClass('active');
				$('.accordion--data').slideUp();
				$(this).addClass('active');
				$(this).find('.accordion--data').slideDown();
			}
		});

//Prevent checkout button
		$(document).on("click", '.checkout-button', function(event) {
			var view = $(this).data('view');
			var hasNonblankVal=false;
			/*var optionValue = $(document).find('.parties option');
			optionValue.each(function( index ) {
			if($( this ).val()!=''){
			hasNonblankVal=true;
			}
			});
			if($(document).find('.parties option').length>1 && hasNonblankVal){
			if($(document).find('.parties :selected').val()==''){
			$(document).find(".checkoutError").html("Please select a consultant party!");
			$(document).find(".checkout-button").attr("data-loading",false);
			event.preventDefault();
			}
			}
			if($(document).find('.consultant_number').length){
			if(vendorId=='37'){
			if($(document).find('.consultant_number').val()==''){
			$(document).find(".checkoutError").html("Please fill the consultant number");
			$(document).find(".checkout-button").attr("data-loading",false);
			event.preventDefault();
			}
			}
			}
			if($(document).find('.current_oyster_count').length){
			if(vendorId=='37'){
			if($(document).find('.current_oyster_count').val()==''){
			$(document).find(".checkoutError").html("Please fill the current oyster count");
			$(document).find(".checkout-button").attr("data-loading",false);
			event.preventDefault();
			}
			}
			}*/
//For Previous Pearl Held Option check
			console.log($('.shipping_pearls_'+view));
			if($('.shipping_pearls_'+view).length){
				if($('.shipping_pearls_'+view).val()===''){
					$(document).find(".checkoutError").html("Please select consultant shipping pearls option");
					$(document).find(".checkout-button").attr("data-loading",false);
					event.preventDefault();
				}
			}
		});
		$(document).on("click", '.product-buy-buttons--cta', function(event) {
			setTimeout(function(){
				if($(document).find('#party_code').length){
					if($("#party_code").val()!=''){
						$("#customerParty").val($("#party_code").val());
						$("#customerParty").attr('readonly','readonly');
					}
				}
			}, 3000);

		});

		$('.header--cart-link').on("click", function(event) {
			setTimeout(function(){
				if($(document).find('#party_code').length){
					if($("#party_code").val()!=''){
						$("#customerParty").val($("#party_code").val());
						$("#customerParty").attr('readonly','readonly');
					}
				}
			}, 2000);

		});

		$(".product-buy-buttons--root").show();
		$('#searchByName').click(function(){
			$('#searchName').show();
			$('#searchActive').hide();
			$('#searchZip').hide();
		});
		$('#searchByActive').click(function(){
			$('#searchName').hide();
			$('#searchZip').show();
			$('#searchActive').show();
			$.LoadingOverlay("show");
			/*theme.genie.getActiveConsultant().then(function(vendorsInfo) {
			$('#searchActive').html(vendorsInfo);
			$.LoadingOverlay("hide");
			});*/
			$.LoadingOverlay("hide");
		});
		/***************Search By Zipcode************************/
		$('#searchByZip').autocomplete({
			minLength: 1,
			ajaxSettings : {crossDomain: true},
//ajaxSettings: { jsonpCallback: 'json_call' },
//dataType: 'jsonp',
			serviceUrl: baseURL + '/account/vendorproduct/getallvendorsbyzip',
			onSelect: function (suggestion) {
				$('#searchActive').html('');
				$('#searchByZip').val(suggestion.value);
				window.location.href = window.location.href+ '?vendor='+suggestion.data+'&selectop='+$('#selectedOption').val();
			},
			onSearchComplete:function (query, suggestion) { }
		});
		/*********************************************************/

	});

	theme.genie = {
		getvendorsDatas: function(vendor_id,partycode) {
			if(partycode!='' &&  partycode!=undefined){
				return $.getJSON(baseURL+'/shopify/process/getvendorinfo/'+vendor_id+'/'+partycode);
			}else{
				return $.getJSON(baseURL+'/shopify/process/getvendorinfo/'+vendor_id);
			}
		},
		checkDiscountCode: function(discountCode) {
			return $.getJSON(baseURL+'/account/vendorproduct/checkdiscountcode/'+discountCode);
		},
		getActiveConsultant: function() {
			return $.ajax(baseURL+'/shopify/process/getActiveVendors/');
		},
		checkPartyCode: function(vendor_id,patyCode) {
			return $.getJSON(baseURL+'/shopify/process/checkCustomerCode/'+vendor_id+'/'+patyCode);
		},
		getCart: function() {
			return $.getJSON('/cart.js');
		},
		_sendAjax: function(params) {
			return $.ajax(params)
				.then(function(data) {
					return data;
				}.bind(this))
		},
		temp: function(url) {
			return this._sendAjax({
				type: 'GET',
				url: url,
				dataType:"json",
			});
		},
		addItemsToCart: function(data) {
			return this._updateCart({
				type: 'POST',
				url: '/cart/add.js',
				data: data,
				dataType: 'json'
			});
		},
		addAttributesToCart: function(data) {
			return this._updateCart({
				type: 'POST',
				url: '/cart.js',
				data: data,
				dataType: 'json'
			});
		},
		_updateCart: function(params) {
			return $.ajax(params)
				.then(function(cart) {
					return cart;
				}.bind(this))
		},
		showError: function(el,message){
			el.append('<div class="errors text-center">'+message+'</div>');
			setTimeout(function(){
				el.find('.errors').remove();
			}, 3000);
		},
		getUrlParams:function(){
			var vars = [], hash;
			var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			for(var i = 0; i < hashes.length; i++)
			{
				hash = hashes[i].split('=');
//vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			}
			return vars;
		},
		setCookie: function(cname, cvalue, exdays) {
			/*var d = new Date();
			d.setTime(d.getTime() + (exdays*24*60*60*1000));
			var expires = "expires="+ d.toUTCString();
			document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
			*/
		},
		deleteCookie: function(cname, cvalue, exdays) {
			var d = new Date();
			d.setTime(d.getTime() + (exdays*24*60*60*1000));
			var expires = "expires=Thu, 01 Jan 1970 00:00:01 GMT";
			document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
		},
		getCookie: function(cname) {
			var name = cname + "=";
			var decodedCookie = decodeURIComponent(document.cookie);
			var ca = decodedCookie.split(';');
			for(var i = 0; i
			<ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
				}
			}
			return "";
		}

	}
	$(document).ready(function(){
		var $patyCodeElement='';
		$patyCodeElement = $("#customerParty");
		$patyCodeElement.on('keydown keyup keypress', function (event) {
			if($patyCodeElement.val().length>7){
				event.stopPropagation();
				if($patyCodeElement.val()!=''){
					if(event.keyCode == 13) {
						event.stopPropagation();
						event.preventDefault();
						return false;
					}
				}
				setTimeout(function() {
					if($patyCodeElement.val()!=''){
						if(event.keyCode == 13 || event.keyCode == 10) {
							event.stopPropagation();
							event.preventDefault();
							return false;
						}
						if($patyCodeElement.val().length>7){
							if (!$patyCodeElement.is('[readonly="readonly"]')){
								checkPatyCode(vendorId);
							}
						}
					}
				}, 1000);
			}
		});
// onblur
		$patyCodeElement.blur(function(){
			event.stopPropagation();
			if($("#customerParty").val().length >0){
				if($("#customerParty").val().length <7){
					var party_code = $("#customerParty").val();
					$("#checkoutError").html(party_code+' Invalid Code');
					$("#customerParty" ).val('');
				}
			}
			setTimeout(function() {
				if($patyCodeElement.val()!=''){
					if(event.keyCode == 13 || event.keyCode == 10) {
						event.stopPropagation();
						event.preventDefault();
						return false;
					}
					if (!$patyCodeElement.is('[readonly="readonly"]')){
						checkPatyCode(vendorId);
					}

				}
			}, 1000);

		});
	});
	if($("#customerParty").length){
		document.getElementById("customerParty").onpaste = function() {
			setTimeout(function() {
				checkPatyCode(vendorId);
			}, 1000);
		};
	}
	$('.checkout-button-mobile, .checkout-button-desktop').on("click", function(event) {
		console.log(1,$("#customerParty").val().length);
		if($("#customerParty").val().length >0){
			if($("#customerParty").val().length <7){
				var party_code = $("#customerParty").val();
				$("#checkoutError").html(party_code+' Invalid Code');
				$("#customerParty" ).val('');
//event.stopPropagation();
//event.preventDefault();
			}
		}
	});
})(jQuery);

function checkPatyCode(vendorId){
	var party_code = $("#customerParty" ).val();
	$.LoadingOverlay("show");
	party_code = party_code.split(' ').join('-');
	theme.genie.checkPartyCode(vendorId,party_code).then(function(codeStatus) {
		if(codeStatus==1 || codeStatus=='1'){
			$("#checkoutError").html('');
		}else {
			$("#checkoutError").html(party_code+' Invalid Code');
			$("#customerParty" ).val('');
		}
		$.LoadingOverlay("hide");
	}.bind(this)).fail(function(XMLHttpRequest){
		$.LoadingOverlay("hide");
	}.bind(this)).always(function() {
		$.LoadingOverlay("hide");
	}.bind(this));
}
function gotoConsultant(redirectUrl){
	window.location=redirectUrl;
}
function getPartiesData(vendor_Id){
	var data_form = {
		cache_vendor    : vendor_Id,
		base_url        : "https://backoffice.itspearltimevendor.com"
	};
	if(data_form.cache_vendor != 'main' && data_form.cache_vendor != ''){
		$.ajax({
			type: 'GET',
			url: data_form.base_url + '/shopify/process/getparties',
			data: data_form,
			async: false,
			jsonpCallback: 'json_call',
			dataType: 'jsonp',
			cache: false,
			success: function(partiesValue) {
				var $partyHtml='';
				$partyHtml = "<option value=''>--Select A Party--</option>";
				$.each(partiesValue, function(i, party){
					var partyname = party.partyName;//&& partyname !== undefined
					if( partyname !== ''){
						if($(".partyNameval").val()==party.event_id){
							var selected='selected';
						}else{
							var selected='';
						}
						$partyHtml += "<option "+selected+" value='"+party.event_id+"'>"+partyname+"</option>";
					}
				});
				$(".parties").html($partyHtml);

			},
			error: function (request, status, error) {
				$(".checkout-button").prop("disabled",false);
				console.log("error-1"); }
		});

	}
}

$('.slidr-itrnl').slick({
	dots: false,
	infinite: true,
	speed: 500,
	slidesToShow: 3,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 2000,
	arrows: true,
	prevArrow:"<button type='button' class='slick-prev pull-left'><svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M19 12H5M5 12L12 19M5 12L12 5' stroke='#fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></div></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M5 12H19M19 12L12 5M19 12L12 19' stroke='#fff' stroke-width='2' stroke-linecap='round'stroke-linejoin='round'/></svg></div></button>",
responsive: [
	{
		breakpoint: 1292,
		settings: {
			slidesToShow: 2,
			slidesToScroll: 1
		}
	},
	{
		breakpoint: 990,
		settings: {
			slidesToShow: 1,
			slidesToScroll: 1
		}
	},
	{
		breakpoint: 400,
		settings: {
			arrows: true,
			slidesToShow: 1,
			slidesToScroll: 1
		}
	}]
});
$('.image--slide').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	autoplay:false,
	asNavFor: '.text--slide'

});

$('.text--slide').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	autoplay:false,
	dots:true,
	asNavFor: '.image--slide'

});
$('.image-with-slider').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: true,
	infinite:false,

	autoplay: true,
	autoplaySpeed: 2000,
	prevArrow:'<button type="button" class="slick-prev pull-left slick-arrow" aria-disabled="false"><div class="carousel--prev" tabindex="0"><div class="icon--root icon--prev"><div></div><div></div><div></div></div></div></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style="display: block;" aria-disabled="false"><div class="carousel--next" tabindex="0"><div class="icon--root icon--next"><div></div><div></div><div></div></div></div></button>',

	responsive: [
	{
		breakpoint: 767,
		settings: {
			dots: true
		}
	}
]

});


$(window).on('load', function() {
   if(vendorId=='' || vendorId==undefined){
     if($('body').attr("data-getcookie")){
       vendorId = $('body').attr("data-getcookie");
     }
   }
	var cmodal = document.getElementById('myModal');  //.imagepicker-items
	$(".product-page--left-column").on('click touchstart','.image-picker-item', function(event){

       event.preventDefault();
      // alert("You have selected "+$(this).data('name'));
    	if($(this).data('name')=='Oyster Opening' || $(this).data('name')=='Pearl Drop'){
			var $this=this;
            setTimeout(function() {
    			if($($this).hasClass("imagepicker-selected")){

            const urlParams = new URLSearchParams(window.location.search);
            const vendor_id = urlParams.get('vendor')
  
    				if(vendorId=='' && vendor_id == undefined){
    					cmodal.style.display = "block";
    					$('#selectedOption').val($($this).data('name'));
    					$('.product-buy-buttons--primary').hide();
                        $('.pconfirm').hide();
                    	$('.popup').show();
    				}
    			}else{
    				$('.product-buy-buttons--primary').show();
    				console.log('not found',vendorId);
    			}
            },500);
		}else{
	$('.product-buy-buttons--primary').show();
}
	});
	$('.close').click(function(){
		cmodal.style.display = "none";
//$("body").find("#myModal").hide();
	});
});
function showVendorPopup(){
	$('.pconfirm').hide();
	$('.popup').show();
}
function hideVendorPopup(){
    let currentDate = new Date().toJSON().slice(0, 10);
	theme.genie.addAttributesToCart({"attributes[hideVendorPopup]": 'VendorRemoved',"attributes[hideVendordate]": currentDate}).then(function(response) {
		window.location.reload();
	}).always(function () {
		window.location.reload();
	}.bind(this));
}
